/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Level of granularity for activity feed history.
 * - Resume (1): Major events only (simulation/quote/contract creation, mandate/contract signatures, certificate generation)
 * - Standard (2): Important events with details grouped by entity and 59-minute time window
 * - Complete (3): All events without grouping
 * 
 * @export
 */
export const GranularityLevelEnum = {
    /**
    * Major events only
    */
    Resume: 1,
    /**
    * Important events with grouped details
    */
    Standard: 2,
    /**
    * All events without grouping
    */
    Complete: 3
} as const;
export type GranularityLevelEnum = typeof GranularityLevelEnum[keyof typeof GranularityLevelEnum];


export function instanceOfGranularityLevelEnum(value: any): boolean {
    for (const key in GranularityLevelEnum) {
        if (Object.prototype.hasOwnProperty.call(GranularityLevelEnum, key)) {
            if (GranularityLevelEnum[key as keyof typeof GranularityLevelEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GranularityLevelEnumFromJSON(json: any): GranularityLevelEnum {
    return GranularityLevelEnumFromJSONTyped(json, false);
}

export function GranularityLevelEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): GranularityLevelEnum {
    return json as GranularityLevelEnum;
}

export function GranularityLevelEnumToJSON(value?: GranularityLevelEnum | null): any {
    return value as any;
}

export function GranularityLevelEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): GranularityLevelEnum {
    return value as GranularityLevelEnum;
}

